// src/components/DataTable.jsx
export default function DataTable({ columns, rows, keyField = "id" }) {
  return (
    <div className="lmd-table-wrap">
      <table className="lmd-table">
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.key}
                className={col.headerClassName || col.className || ""}
                style={col.headerStyle || col.style}
              >
                {col.title}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="lmd-table-empty">
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 8 }}>
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ color: "var(--clr-text-muted)", opacity: .5 }}>
                    <rect x="3" y="3" width="18" height="18" rx="2"/>
                    <path d="M3 9h18M9 21V9"/>
                  </svg>
                  Sin registros
                </div>
              </td>
            </tr>
          ) : (
            rows.map((r) => (
              <tr key={r[keyField]}>
                {columns.map((col) => (
                  <td
                    key={col.key}
                    className={col.tdClassName || col.className || ""}
                    style={col.tdStyle || col.style}
                  >
                    {col.render ? col.render(r) : r[col.key]}
                  </td>
                ))}
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
